import { SVGProps } from 'react';

export const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={24}
    width={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.39789 5.39789 0 12 0C18.6021 0 24 5.39789 24 12C24 18.6021 18.6021 24 12 24C5.39789 24 0 18.6021 0 12ZM12 1.84615C6.41749 1.84615 1.84615 6.41749 1.84615 12C1.84615 17.5825 6.41749 22.1538 12 22.1538C17.5825 22.1538 22.1538 17.5825 22.1538 12C22.1538 6.41749 17.5825 1.84615 12 1.84615Z"
    />
    <path d="M11.9998 10.0003H10.9998C10.7346 10.0003 10.4803 10.1057 10.2927 10.2932C10.1052 10.4807 9.99985 10.7351 9.99985 11.0003C9.99985 11.2655 10.1052 11.5199 10.2927 11.7074C10.4803 11.8949 10.7346 12.0003 10.9998 12.0003H11.9998V18.0003C11.9998 18.2655 12.1052 18.5199 12.2927 18.7074C12.4803 18.8949 12.7346 19.0003 12.9998 19.0003C13.2651 19.0003 13.5194 18.8949 13.7069 18.7074C13.8945 18.5199 13.9998 18.2655 13.9998 18.0003V12.0003C13.9998 11.4699 13.7891 10.9612 13.4141 10.5861C13.039 10.211 12.5303 10.0003 11.9998 10.0003Z" />
    <path d="M12 7.99969C12.8284 7.99969 13.5 7.32812 13.5 6.49969C13.5 5.67127 12.8284 4.99969 12 4.99969C11.1716 4.99969 10.5 5.67127 10.5 6.49969C10.5 7.32812 11.1716 7.99969 12 7.99969Z" />
  </svg>
);
